export const baseUrl = "https://relayserver.vsatx.in";